import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

import {
  AudioDeviceSelector,
  DeviceSelector,
  VideoDeviceSelector,
} from '../../ControlsClient/DeviceSelector/DeviceSelector';
import { useTranslation } from 'react-i18next';
import { ModalUI } from '../../UI/Modal/Modal';
import ButtonUI from '../../UI/Button/Button';
import { DeviceDialogStyle } from './style';

interface DeviceDialogProps {
  open: boolean;
  onClose: () => void;
  /**
   * Optional extra styles applied directly to the `.modal-wrapper` Box.
   * Practitioner controls pass `DeviceDialogStyle.deviceModalVideoArea`
   * so the modal centres in the video area rather than the whole viewport.
   */
  wrapperSx?: SxProps<Theme>;
}

const mergeWrapperSx = (extra?: SxProps<Theme>): SxProps<Theme> =>
  extra ? ({ ...DeviceDialogStyle.deviceModal, ...extra } as SxProps<Theme>) : DeviceDialogStyle.deviceModal;

export default function DeviceDialog({ open, onClose, wrapperSx }: DeviceDialogProps) {
  const { t } = useTranslation();

  return (
    <ModalUI open={open} className="device-dialog" wrapperSx={mergeWrapperSx(wrapperSx)} onCloseHandler={onClose}>
      <Box sx={{ width: '100%' }}>
        <DeviceSelector />
        <Box sx={DeviceDialogStyle.actions}>
          <ButtonUI text={t('Done').toString()} type="modalText" onClickHandler={onClose} />
        </Box>
      </Box>
    </ModalUI>
  );
}

export function AudioDeviceDialog({ open, onClose, wrapperSx }: DeviceDialogProps) {
  const { t } = useTranslation();

  return (
    <ModalUI open={open} className="device-dialog" wrapperSx={mergeWrapperSx(wrapperSx)} onCloseHandler={onClose}>
      <Box sx={{ width: '100%' }} data-testid="pwid-audio-device-dialog">
        <AudioDeviceSelector />
        <Box sx={DeviceDialogStyle.actions}>
          <ButtonUI
            text={t('Done').toString()}
            type="modalText"
            onClickHandler={onClose}
            dataTestId="pwid-audio-device-dialog-done"
          />
        </Box>
      </Box>
    </ModalUI>
  );
}

export function VideoDeviceDialog({ open, onClose, wrapperSx }: DeviceDialogProps) {
  const { t } = useTranslation();

  return (
    <ModalUI open={open} className="device-dialog" wrapperSx={mergeWrapperSx(wrapperSx)} onCloseHandler={onClose}>
      <Box sx={{ width: '100%' }} data-testid="pwid-video-device-dialog">
        <VideoDeviceSelector />
        <Box sx={DeviceDialogStyle.actions}>
          <ButtonUI
            text={t('Done').toString()}
            type="modalText"
            onClickHandler={onClose}
            dataTestId="pwid-video-device-dialog-done"
          />
        </Box>
      </Box>
    </ModalUI>
  );
}
